export default "__VITE_ASSET__DwzKSLNe__"